import React from 'react';

import { Button } from 'primereact/button';

import DeleteConfirmationDialog from 'ui/shared/DeleteConfirmationDialog';

interface DepartmentZonesListProps {
  areas: any[];
  onEdit: (index: number) => void;
  onDelete: (index: number) => void;
  entityType?: string;
  readOnly?: boolean;
}

export const DepartmentZonesList: React.FC<DepartmentZonesListProps> = ({
  areas,
  onEdit,
  onDelete,
  entityType = 'зону обслуживания',
  readOnly = false
}) => {
  const [deleteIndex, setDeleteIndex] = React.useState<number | null>(null);

  const buildAddressText = (area: any) => {
    const parts: string[] = [];

    if (area.region) parts.push(area.region);
    if (area.county) parts.push(area.county);

    const city =
      area.cityFias?.fullName || area.cityFias?.name || area.customCity;
    if (city) parts.push(city);

    if (area.district) parts.push(area.district);

    const street = area.streetFias?.name || area.customStreet;
    if (street) parts.push(street);

    const house = area.houseFias?.name || area.customHouse;
    if (house) parts.push(house);

    if (area.latitude !== null && area.latitude !== undefined)
      parts.push(`широта: ${area.latitude}`);
    if (area.longitude !== null && area.longitude !== undefined)
      parts.push(`долгота: ${area.longitude}`);

    return parts.join(' - ');
  };

  return (
    <div className="flex flex-column mt-3">
      {areas.map((area, index) => (
        <div
          key={index}
          className="flex align-items-center gap-1 p-2 pt-1 border-round surface-border"
        >
          <span className="flex-grow-1">
            {buildAddressText(area)}
          </span>
          {!readOnly && (
            <Button
              size="small"
              style={{
                width: '36px'
              }}
              icon="pi pi-pencil"
              severity="secondary"
              onClick={() => onEdit(index)}
            />
          )}
          {!readOnly && (
            <Button
              size="small"
              style={{
                width: '36px'
              }}
              icon="pi pi-trash"
              severity="danger"
              onClick={() => setDeleteIndex(index)}
            />
          )}
        </div>
      ))}

      <DeleteConfirmationDialog
        visible={deleteIndex !== null}
        onHide={() => setDeleteIndex(null)}
        onConfirm={() => {
          if (deleteIndex !== null) {
            onDelete(deleteIndex);
            setDeleteIndex(null);
          }
        }}
        entityType={entityType}
      />
    </div>
  );
};
